const labels = {
  "roles.player": "Player",
  "roles.coach": "Coach",
  "roles.parent": "Parent",
  "roles.account_owner": "Account Owner",
  "roles.owner": "Owner",
  "roles.admin": "Admin",
  "roles.member": "Player",
  "roles.analyst": "Analyst",
  "roles.guest": "Guest",
  "roles.demo": "Demo",
};

export const roles = {
  ...labels,
};
